import { Layout as AntdLayout } from 'antd';
import React, { useState } from 'react';

import classes from './Layout.module.less';

import Content from '../Content/Content';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';

type Props = { children: JSX.Element };

const Layout = ({ children }: Props) => {
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarCollapsed(!isSidebarCollapsed);
	};

	return (
		<AntdLayout className={classes.container}>
			<Sidebar isCollapsed={isSidebarCollapsed} />
			<AntdLayout className={classes.body}>
				<Header isSidebarCollapsed={isSidebarCollapsed} onToggleSidebar={toggleSidebar} />
				<Content>{children}</Content>
				<Footer />
			</AntdLayout>
		</AntdLayout>
	);
};

export default Layout;
